import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./form-field.scss";

import Alert from "../../Alert/Alert";

const FormFieldValidation = ({ list, className, ...props }) => {
  const classes = classnames("form-field-validation", className);

  const renderMessages = () => {
    return list.map((validationItem, i) => {
      const { fieldId, valid, messageLabel, message } = validationItem;

      return (
        <div
          key={`${fieldId}-form-validation-${i}`}
          className="form-field-validation__item"
          role="listitem"
        >
          <Alert type={valid ? "success" : "error"} inline>
            {messageLabel}
          </Alert>{" "}
          <span className="form-field-validation__item-message">{message}</span>
        </div>
      );
    });
  };

  return (
    <div className={classes} role="list" {...props}>
      {renderMessages()}
    </div>
  );
};

FormFieldValidation.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      fieldId: PropTypes.string,
      valid: PropTypes.bool,
      messageLabel: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
};

export default FormFieldValidation;
